import React from 'react'
import {useSelector} from 'react-redux'
import {Redirect, Route} from 'react-router-dom'

function PrivateMemberRoute({children, ...rest}) {
  const memberLoggedIn = useSelector((state) => state.member.memberLoggedIn)
  return (
    <Route
      {...rest}
      render={({location}) =>
        memberLoggedIn ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: {from: location},
            }}
          />
        )
      }
    />
  )
}

export default PrivateMemberRoute
